import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BidChatDrawerService } from '@features/bid-chat/services/bid-chat-drawer.service';
import { BidChatRow, BidChatTarget, BidChatView } from '@features/bid-chat/models/bid-chat.model';
import { targetFromRow } from '@features/bid-chat/services/bid-chat.service';

/**
 * Content of the layout drawer while the bid chat is open (#47189): the customer's Chat logs, or
 * one thread. What it shows lives in `BidChatDrawerService`, set by the header and the bids list.
 */
@Component({
  selector: 'app-chat-drawer',
  templateUrl: './chat-drawer.component.html',
  styleUrls: ['./chat-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatDrawerComponent {
  readonly view$ = this.drawerService.view$;

  constructor(private drawerService: BidChatDrawerService) {}

  threadTarget(view: BidChatView | null): BidChatTarget | null {
    return view?.mode === 'thread' ? view.target : null;
  }

  showLogs(): void {
    this.drawerService.openLogs();
  }

  close(): void {
    this.drawerService.close();
  }

  openRow(row: BidChatRow): void {
    this.drawerService.openThread(targetFromRow(row), true);
  }
}
